<template>
  <!-- Tabla usuarios -->
  <v-container>
    <v-row>
      <v-col md="12">
        <v-card>
          <v-card-title>Usuario<v-divider class="mx-4" inset vertical></v-divider>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col sm="6" cols="12">
                <v-text-field v-model="listadousuario.dni" prepend-inner-icon="mdi-magnify"
                  label="Buscar por Dni o Nombre o Apellido" class=".text-sm-body-2"></v-text-field>
              </v-col>
              <v-col sm="6" cols="12" class="text-right">
                <v-btn color="primary" small @click="nuevoUsuario">Nuevo usuario</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-data-table :headers="listadousuario.headers" :items="listadousuario.data" class="elevation-1"
                  :server-items-length="listadousuario.total" item-key="usuarioid" @update:options="cargarUsuarioPagina"
                  :footer-props="listadousuario.footerProps" :loading="loading">
                  <template #item.full_name="{ item }">{{ item.apellido }}, {{ item.nombre }}</template>
                  <template v-slot:top>
                    <v-dialog v-model="dialog" max-width="500px">
                      <v-card>
                        <v-card-title>
                          <span class="text-h5">{{ tituloDialog }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="usuarioEdit.dni" label="Dni"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="usuarioEdit.apellido" label="Apellido"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="usuarioEdit.nombre" label="Nombre"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="12">
                                <v-select multiple persistent-hint v-model="usuarioEdit.rolid" :items="listadorole"
                                  item-text="nombre" item-value="rolId" label="Seleccione rol"></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field v-model="usuarioEdit.email" label="Email"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="cerrar">
                            Cerrar
                          </v-btn>
                          <v-btn color="blue darken-1" text @click="grabar">
                            Grabar
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="editarUsuario(item)">
                      mdi-pencil
                    </v-icon>
                    <v-icon small @click="eliminarusuario(item.usuarioid)">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsuarioService from "../../services/Usuario.service";
import RolService from "../../services/Rol.service";

export default {
  computed: {
    filtro() {
      this.listadousuario.dni;
      return this.listadousuario;
    },
  },
  watch: {
    filtro() {
      this.listadousuario.pagina = 1;
      this.cargarTablaUsuario();
    },
  },
  data() {
    return {
      dialog: false,
      tituloDialog: "",
      loading: false,
      listadorole: [],
      usuario: {
        dni: null,
        rolid: 2,
      },
      usuarioEditIndex: -1,
      usuarioEdit: {},
      tablalistadousuario: [],
      listadousuario: {
        dni: "",
        total: 0,
        data: [],
        pagina: 1,
        cantidad: 10,
        footerProps: {
          itemsPerPageOptions: [5, 10, 15, 20],
        },
        headers: [
          { text: "DNI", value: "dni" },
          { text: "Apellido, Nombre", value: "full_name" },
          { text: "Rol", value: "rol" },
          { text: "Email", value: "email" },
          { text: "Accion", value: "actions", sortable: false },
        ],
      },
    };
  },
  methods: {
    cargarTablaRol() {
      RolService.ObtenerTodo().then((res) => {
        this.listadorole = res.data;
      });
    },
    editarUsuario(item) {
      this.tituloDialog = "Editar usuario";
      this.usuarioEditIndex = this.listadousuario.data.indexOf(item);
      this.usuarioEdit = Object.assign({}, item);
      this.dialog = true;
    },
    nuevoUsuario() {
      this.tituloDialog = "Nuevo usuario";
      this.usuarioEditIndex = {};
      this.usuarioEdit = {};
      this.dialog = true;
    },
    cargarTablaUsuario() {
      this.loading = true;
      UsuarioService.ObtenerTodoPaginado(
        this.listadousuario.dni,
        this.listadousuario.pagina,
        this.listadousuario.cantidad
      ).then((res) => {
        this.listadousuario.total = res.data.total;
        this.listadousuario.data = res.data.lista;
        this.loading = false;
      });
    },
    cerrar() {
      this.dialog = false;
      this.tituloDialog = "";
      this.usuarioEdit = {};
      this.usuario = {};
    },
    grabar() {
      if ("usuarioid" in this.usuarioEdit) {
        UsuarioService.Modificar(this.usuarioEdit).then(
          (res) => {
            Object.assign(
              this.listadousuario.data[this.usuarioEditIndex],
              res.data
            );
            this.dialog = false;
          },
          (err) => {
            this.$toast.error(err.response.data);
          }
        );
      } else {
        this.usuario = this.usuarioEdit;
        this.insertarusuario();
      }
    },
    cargarUsuarioPagina(options) {
      this.listadousuario.pagina = options.page;
      this.listadousuario.cantidad = options.itemsPerPage;
      this.cargarTablaUsuario();
    },
    async insertarusuario() {
      var res = await confirm("¿Desea registrar el usuario?");
      if (res) {
        if (this.usuario.dni != null || this.usuario.dni != "") {
          UsuarioService.Insertar(this.usuario).then(
            (res) => {

              this.cargarTablaUsuario();
              this.cerrar();
            },
            (err) => {
              this.$toast.error(err.response.data);
            }
          );
        }
      }
    },
    async eliminarusuario(usuarioid) {
      var res = await confirm("¿Desea eliminar el usuario?");
      if (res) {
        UsuarioService.Eliminar(usuarioid).then(
          (res) => {
            this.$toast.success("Se eliminado con exito");
            this.cargarTablaUsuario();
          },
          (err) => {
            this.$toast.error(err.response.data);
          }
        );
      }
    },
  },
  mounted() {
    this.cargarTablaUsuario();
    this.cargarTablaRol();
  },
};
</script>
